var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "novel-list-item" },
    [
      _c(
        "router-link",
        {
          staticClass: "novel-list-item-link",
          attrs: {
            to: { name: "editor", params: { novelId: _vm.novel.novelId } },
          },
        },
        [
          _c("div", { staticClass: "novel-thumbnail-wrapper" }, [
            _c(
              "div",
              { staticClass: "novel-thumbnail" },
              [
                _c("image-view", {
                  key: _vm.coverImageVersion,
                  staticClass: "novel-image",
                  attrs: {
                    src: _vm.getImageKey,
                    placeholder: "/img/placeholders/novel.png",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "novel-pin",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onClickPinned.apply(null, arguments)
                  },
                },
              },
              [
                _c("IconPin", {
                  staticClass: "pin-icon",
                  class: { active: _vm.novel.pinned },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "novel-info" }, [
            _c("div", { staticClass: "novel-title line-clamp" }, [
              _vm._v(_vm._s(_vm.novel.title)),
            ]),
            _c("div", { staticClass: "novel-meta-row" }, [
              _vm.workStatusLabel
                ? _c("span", { staticClass: "novel-status-badge" }, [
                    _vm._v(_vm._s(_vm.workStatusLabel)),
                  ])
                : _vm._e(),
              _c(
                "span",
                { staticClass: "novel-date" },
                [
                  _c("IconReload", { staticClass: "date-icon" }),
                  _vm._v(" " + _vm._s(_vm.toUpdatedAt) + " "),
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "novel-date" },
                [
                  _c("IconPencil", { staticClass: "date-icon" }),
                  _vm._v(" " + _vm._s(_vm.toCreatedAt) + " "),
                ],
                1
              ),
            ]),
            _vm.novel.groups && _vm.novel.groups.length > 0
              ? _c(
                  "div",
                  { staticClass: "novel-groups-row" },
                  _vm._l(_vm.novel.groups, function (group) {
                    return _c(
                      "span",
                      { key: group.groupId, staticClass: "novel-group-chip" },
                      [
                        _c("IconFolderHeart", {
                          staticClass: "group-chip-icon",
                        }),
                        _vm._v(" " + _vm._s(group.name) + " "),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c("div", { staticClass: "novel-menu-area" }, [
        _c(
          "button",
          { staticClass: "novel-menu-button", on: { click: _vm.toggleMenu } },
          [_c("IconVerticalEllipsis", { staticClass: "icon-20" })],
          1
        ),
        _vm.isMenuOpen
          ? _c("div", { staticClass: "menu-popover" }, [
              _c(
                "button",
                {
                  staticClass: "menu-item",
                  on: { click: _vm.showCopyNovelDialog },
                },
                [
                  _c("IconCopy", { staticClass: "menu-item-icon" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("homePage.novelList.listItem.copyNovel"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "menu-item",
                  on: { click: _vm.showGroupingDialog },
                },
                [
                  _c("IconFolderHeart", { staticClass: "menu-item-icon" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("homePage.novelList.listItem.grouping"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "button",
                { staticClass: "menu-item", on: { click: _vm.importNovel } },
                [
                  _c("IconUpload", { staticClass: "menu-item-icon" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("homePage.novelList.listItem.importManuscript")
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "menu-item menu-item-danger",
                  on: { click: _vm.deleteNovel },
                },
                [
                  _c("IconTrash", { staticClass: "menu-item-icon" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("homePage.novelList.listItem.deleteNovel"))
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm.isMenuOpen
        ? _c("div", {
            staticClass: "menu-backdrop",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggleMenu.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
      _c("input", {
        ref: "input",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".txt,.docx", multiple: "" },
        on: {
          change: function ($event) {
            return _vm.onSelectFile()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }